/** The record QuantisAI will be told about with the next message, which the person can leave out for that message. */
import { FileText, Plus, X } from '@/shared/ui/icons';
import { recordChipText, type SIRecordContext } from './siRecordContext';

export function SIRecordChip({ record, included, onToggle }: { record: SIRecordContext; included: boolean; onToggle: () => void }) {
  const text = recordChipText(record);
  return <div className="flex px-3 pt-1.5" data-slot="si-record-chip">
    {included
      ? <span className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-muted py-0.5 pl-2.5 pr-1 text-xs text-foreground">
          <FileText className="size-3.5 shrink-0 text-muted-foreground" aria-hidden />
          <span className="truncate">Looking at: {text}</span>
          <button type="button" onClick={onToggle} className="grid size-5 shrink-0 place-items-center rounded-full text-muted-foreground hover:bg-background hover:text-foreground" aria-label={`Leave ${record.label} out of the next message`}>
            <X className="size-3" aria-hidden />
          </button>
        </span>
      : <button type="button" onClick={onToggle} className="inline-flex max-w-full items-center gap-1.5 rounded-full py-0.5 pl-1.5 pr-2.5 text-xs text-muted-foreground hover:bg-muted hover:text-foreground">
          <Plus className="size-3.5 shrink-0" aria-hidden />
          <span className="truncate">Include {record.label}</span>
        </button>}
  </div>;
}
